const ARABIC_EGYPT = 'ar-EG';
const DANISH_DENMARK = 'da-DK';
const GERMAN_GERMANY = 'de-DE';
const ENGLISH_UNITED_STATES = 'en-US';
const SPANISH_SPAIN = 'es-ES';
const ESTONIAN_ESTONIA = 'et-EE';
const FINNISH_FINLAND = 'fi-FI';
const FRENCH_FRANCE = 'fr-FR';
const PORTUGUESE_PORTUGAL = 'pt-PT';
const RUSSIAN_RUSSIA = 'ru-RU';
const SWEDISH_SWEDEN = 'sv-SE';
const UKRAINIAN_UKRAINE = 'uk-UA';
const NORWEGIAN_NORWAY = 'nb-NO';
const TURKISH_TURKEY = 'tr-TR';
const POLISH_POLAND = 'pl-PL';
const DUTCH_NETHERLANDS = 'nl-NL';
const DUTCH_BELGIUM = 'nl-BE';
const ARABIC_SYRIA = 'ar-SY';
const LITHUANIAN_LITHUANIA = 'lt-LT';
const SOMALI_SOMALIA = 'so-SO';
const PASHTO_AFGHANISTAN = 'ps-AF';
const FARSI_IRAN = 'fa-IR';
const THAI_THAILAND = 'th-TH';
const ROMANIAN_ROMANIA = 'ro-RO';
const SWAHILI_KENYA = 'sw-KE';
const MANDARIN_CHINA = 'zh-CN';
const ARABIC_UNITED_ARAB_EMIRATES = 'ar-AE';
const ARABIC_BAHRAIN = 'ar-BH';
const ARABIC_ALGERIA = 'ar-DZ';
const ARABIC_IRAQ = 'ar-IQ';
const ARABIC_JORDAN = 'ar-JO';
const ARABIC_KUWAIT = 'ar-KW';
const ARABIC_LEBANON = 'ar-LB';
const ARABIC_LIBYA = 'ar-LY';
const ARABIC_MOROCCO = 'ar-MA';
const ARABIC_OMAN = 'ar-OM';
const ARABIC_QATAR = 'ar-QA';
const ARABIC_SAUDI_ARABIA = 'ar-SA';
const ARABIC_TUNISIA = 'ar-TN';
const ARABIC_YEMEN = 'ar-YE';

const languageMappings = {
  'eng': ENGLISH_UNITED_STATES,
  'fin': FINNISH_FINLAND,
  'rus': RUSSIAN_RUSSIA,
  'est': ESTONIAN_ESTONIA,
  'ara': ARABIC_EGYPT,
  'ukr': UKRAINIAN_UKRAINE,
  'swe': SWEDISH_SWEDEN,
  'dan': DANISH_DENMARK,
  'deu': GERMAN_GERMANY,
  'spa': SPANISH_SPAIN,
  'por': PORTUGUESE_PORTUGAL,
  'fra': FRENCH_FRANCE,
  'nor': NORWEGIAN_NORWAY,
  'tur': TURKISH_TURKEY,
  'pol': POLISH_POLAND,
  'dut': DUTCH_NETHERLANDS,
  'nld': DUTCH_BELGIUM,
  'lit': LITHUANIAN_LITHUANIA,
  'som': SOMALI_SOMALIA,
  'pus': PASHTO_AFGHANISTAN,
  'fas': FARSI_IRAN,
  'tha': THAI_THAILAND,
  'ron': ROMANIAN_ROMANIA,
  'swa': SWAHILI_KENYA,
  'cmn': MANDARIN_CHINA,
  'ara-ae': ARABIC_UNITED_ARAB_EMIRATES,
  'ara-bh': ARABIC_BAHRAIN,
  'ara-dz': ARABIC_ALGERIA,
  'ara-iq': ARABIC_IRAQ,
  'ara-jo': ARABIC_JORDAN,
  'ara-kw': ARABIC_KUWAIT,
  'ara-lb': ARABIC_LEBANON,
  'ara-ly': ARABIC_LIBYA,
  'ara-ma': ARABIC_MOROCCO,
  'ara-om': ARABIC_OMAN,
  'ara-qa': ARABIC_QATAR,
  'ara-sy': ARABIC_SYRIA,
  'ara-sa': ARABIC_SAUDI_ARABIA,
  'ara-tn': ARABIC_TUNISIA,
  'ara-ye': ARABIC_YEMEN,
  
};

export default languageMappings;
